import * as React from 'react';
import { SVGIcon, SVGIconProps } from '../SvgIcon';

export let GlobeIcon = (props: SVGIconProps) => (
    <SVGIcon viewBox="0 0 16 16" width="16" height="16" {...props}>
        <path d="M8,16a8,8,0,1,1,8-8A8,8,0,0,1,8,16Zm1.6-1.8a6.4,6.4,0,0,0,3.2-1.968V7.2a1.6,1.6,0,0,1-1.6-1.6V2.456a6.36,6.36,0,0,0-2.4-.8V2.4A1.6,1.6,0,0,1,7.2,4v.8A1.6,1.6,0,0,1,5.6,6.4V8H8A1.6,1.6,0,0,1,9.6,9.6Zm-3.2,0V12a1.6,1.6,0,0,1-1.6-1.6V9.6H4.4A1.2,1.2,0,0,1,3.2,8.4v-2H1.8a6.408,6.408,0,0,0,4.6,7.8Z" />
    </SVGIcon>
);
